export class R3Promise<Success, Error> extends Promise<Success> {
  constructor(executor: (resolve: (value: Success | PromiseLike<Success>) => void, reject: (reason: Error) => void) => void) {
    super(executor);
    // Object.setPrototypeOf(this, new.target.prototype);  // restore prototype chain
  }
}

export declare interface IR3Promise<Success, Error = unknown> {
  then<TResult1 = Success, TResult2 = never>(onfulfilled?: ((value: Success) => TResult1 | PromiseLike<TResult1>) |
    undefined | null, onrejected?: ((reason: Error) => Error | PromiseLike<Error>) | undefined | null):
    Promise<TResult1 | TResult2>;

  catch<Error = never>(onrejected?: ((reason: Error) => Error | PromiseLike<Error>) | undefined | null): Promise<Error>;
}

type s = { success: boolean }; type r = { error: string }
const c = new R3Promise<s, r>((resolve, reject) => {
  resolve({ success: true })
  reject({ error: "error" })
})